import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function AppleSuccess({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Get token from URL hash
    const hash = location.hash.substring(1); // Remove the # symbol
    const token = hash;

    if (token && token.length > 10) {
      console.log('Apple auth successful, token received');
      toast.success('Signed in with Apple successfully!');
      onLogin(token);
      
      // Navigate to onboarding
      setTimeout(() => {
        navigate('/onboarding');
      }, 500);
    } else {
      console.error('No token in URL hash');
      toast.error('Apple authentication failed');
      setTimeout(() => {
        navigate('/auth');
      }, 2000);
    }
  }, [location, navigate, onLogin]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto mb-4" />
        <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
          Completing Apple Sign In...
        </h2>
        <p className="text-muted-foreground">
          Almost there! Setting up your account
        </p>
      </div>
    </div>
  );
}
